import React from 'react';
import PropTypes from 'prop-types';
import { useInternationalization } from '@progress/kendo-react-intl';
import { formatDateByLanguage } from "utils";

const CellDate = ({ date, isExpired, convertTimezone = true }) => {
    const intl = useInternationalization();
    const languageDateFormat = formatDateByLanguage(intl.locale);

    if (!date) {
        return <td></td>;
    }

    let displayDate;

    if (convertTimezone) {
        // ✅ Caso normale: la data viene mostrata nel fuso locale dell’utente
        displayDate = new Date(date);
    } else {
        // ✅ Caso “no timezone”: blocchiamo la conversione locale
        const utcDate = new Date(date);
        const year = utcDate.getUTCFullYear();
        const month = utcDate.getUTCMonth();
        const day = utcDate.getUTCDate();
        displayDate = new Date(Date.UTC(year, month, day));
    }

    return (
        <td
            colSpan="1"
            className={isExpired ? "c-row-expired" : undefined}
            role="gridcell"
            aria-colindex="9"
            aria-selected="false"
            data-grid-col-index="8"
        >
            {intl.formatDate(displayDate, languageDateFormat)}
        </td>
    );
};

CellDate.propTypes = {
    date: PropTypes.string,
    isExpired: PropTypes.bool,
    /**
     * Se true → converte la data nel fuso locale dell’utente (default)
     * Se false → mostra la data come UTC, senza shift di timezone
     */
    convertTimezone: PropTypes.bool,
};

export default CellDate;
